module.exports = __webpack_public_path__ + "img/logo.4dd9bee0.svg";